import React, {useRef, useState, useEffect} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {observer, inject} from "mobx-react";

import {Formik, Form, useField} from 'formik';
import * as Yup from 'yup';
import {TextInput, CheckboxInput, RadioInput, TextArea} from "@components/Form/FormFields";


const SignupForm = ({...props}) => {

    const captchaRef = useRef();
    const thankYouRef = useRef();

    const [formAccepted, setFormAccepted] = useState(false);
    useEffect(() => {
        if (formAccepted) {
            thankYouRef.current.scrollIntoView();
        }
    }, [formAccepted])

    const onSubmitWithReCAPTCHA = async (values, {setSubmitting, resetForm}) => {
        const recaptcha = await captchaRef.current.executeAsync();


        props.berikssonStore.register({...values, recaptcha}).then(res => {
            setSubmitting(false);
            setFormAccepted(true);
        }, (error) => {
            captchaRef.current.reset();
            console.log("error", error);
            setSubmitting(false);
        });
        //alert(JSON.stringify(values, null, 2));
    }


    return (
        <React.Fragment>
            {formAccepted
                ? <h3 ref={thankYouRef}>Tack för din registrering.</h3>
                :
                <Formik
                    validateOnMount={false}
                    initialValues={{
                        cultureCode: props.cultureCode,
                        nodeId: props.nodeId,
                        recaptcha: '',
                        customerName: '',
                        customerOrganisationNumber: '',
                        customerEmail: '',
                        customerEmailInvoice: true,
                        customerAddress1: '',
                        customerPostalCode: '',
                        customerCity: '',

                        customerUseSeparateShipping: false,
                        customerShippingName: '',
                        customerShippingAddress1: '',
                        customerShippingPostalCode: '',
                        customerShippingCity: '',

                        customerShippingOfficeHours: '',
                        customerShippingNote: '',

                        memberFirstName: '',
                        memberLastName: '',
                        memberEmail: '',
                        memberPhone: '',
                        //memberMobilePhone: '',
                        memberMessage: '',
                        memberNewsletter: false,
                        memberConsent: false


                    }}
                    validationSchema={Yup.object({
                        //recaptcha: Yup.string().required(),

                        customerName: Yup.string()
                            .required('Måste anges'),
                        customerOrganisationNumber: Yup.string()
                            .required('Måste anges')
                            .matches(/^\d{6}-\d{4}$/, "Formatet måste vara XXXXXX-XXXX"),
                        customerEmail: Yup.string()
                            .email('Ogiltig epostadress')
                            .required('Måste anges'),
                        customerAddress1: Yup.string()
                            .required('Måste anges'),

                        customerPostalCode: Yup.string()
                            .required('Måste anges'),

                        customerCity: Yup.string()
                            .required('Måste anges'),

                        customerShippingName: Yup.string().when("customerUseSeparateShipping", {
                            is: (customerUseSeparateShipping) => customerUseSeparateShipping === true,
                            then: () => Yup.string().required('Måste anges'),
                        }),

                        customerShippingAddress1: Yup.string().when("customerUseSeparateShipping", {
                            is: (customerUseSeparateShipping) => customerUseSeparateShipping === true,
                            then: () => Yup.string().required('Måste anges'),
                        }),

                        customerShippingPostalCode: Yup.string().when("customerUseSeparateShipping", {
                            is: (customerUseSeparateShipping) => customerUseSeparateShipping === true,
                            then: () => Yup.string().required('Måste anges'),
                        }),

                        customerShippingCity: Yup.string().when("customerUseSeparateShipping", {
                            is: (customerUseSeparateShipping) => customerUseSeparateShipping === true,
                            then: () => Yup.string().required('Måste anges'),
                        }),

                        customerShippingOfficeHours: Yup.string().required("Du måste ange när du kan ta emot leveranser")
                            .oneOf(['Ja', 'Nej'], 'Du måste välja Ja eller Nej'),

                        customerShippingNote: Yup.string().when("customerShippingOfficeHours", {
                            is: (customerShippingOfficeHours) => customerShippingOfficeHours === "Nej",
                            then: () => Yup.string().required('Du måste beskriva när du kan ta emot leveranser'),
                        }),

                        memberFirstName: Yup.string()
                            .required('Måste anges'),
                        memberLastName: Yup.string()
                            .required('Måste anges'),
                        memberEmail: Yup.string()
                            .email('Ogiltig e-postadress')
                            .required('Måste anges'),

                        memberPhone: Yup.string()
                            .required('Måste anges'),
                        // memberMobilePhone: Yup.string()
                        //     .required('Måste anges'),

                        memberMessage: '',
                        memberNewsletter: false,
                        memberConsent: Yup.bool().oneOf([true], 'Du måste godkänna att vi hanterar din data.'),


                        // acceptedTerms: Yup.boolean()
                        //     .required('Required')
                        //     .oneOf([true], 'You must accept the terms and conditions.'),
                        // jobType: Yup.string()
                        //     .oneOf(
                        //         ['designer', 'development', 'product', 'other'],
                        //         'Invalid Job Type'
                        //     )
                        //     .required('Required'),
                    })}
                    onSubmit={onSubmitWithReCAPTCHA}
                    // onSubmit={(values, {setSubmitting}) => {
                    //     console.log("submitting", values)
                    //    
                    //         captchaRef.current.executeAsync().then(token => {
                    //             console.log("token", token);
                    //         }
                    //     )
                    //
                    //     // props.berikssonStore.register(values).then(res => {
                    //     //     console.log("berikssonStore.register() => ", res)
                    //     // })
                    //     // //alert(JSON.stringify(values, null, 2));
                    //
                    //     setSubmitting(false);
                    //
                    // }}

                >
                    {({values, setSubmitting, isSubmitting, handleBlur, setFieldValue, isValid, errors, touched}) => {
                        //  noValidate
                        const handleFieldBlur = (e) => {
                            // console.log("$$$$", isSubmitting);
                            // if (!values.recaptcha) {
                            //     captchaRef.current.execute();
                            //     setSubmitting(true);
                            // }
                            // handleBlur(e);
                        }
                        return <Form style={{maxWidth: 800, marginLeft: "auto", marginRight: "auto"}}>
                            <h6 className="text-bold">Företagsuppgifter</h6>
                            <hr className="mb-3"/>
                            <div className={"row"}>
                                <div className={"col-sm-6"}>
                                    <TextInput
                                        label="Företagsnamn"
                                        name="customerName"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-sm-6 "}>
                                    <TextInput
                                        label="Organisationsnummer"
                                        name="customerOrganisationNumber"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        //placeholder="Doe"
                                    />
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-sm-6 "}>
                                    <TextInput
                                        label="Företagets E-postadress (för faktura)"
                                        name="customerEmail"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-sm-6 "}>
                                    <CheckboxInput
                                        id="customerEmailInvoice"
                                        label="Faktura per epost"
                                        name="customerEmailInvoice"
                                        //onBlur={handleFieldBlur}
                                    >
                                        Kryssa ur rutan om du önskar fakturan per brevpost.
                                    </CheckboxInput>
                                </div>
                            </div>

                            <div className={"row"}>
                                <div className={"col-sm-12 "}>
                                    <TextInput
                                        label="Adress"
                                        name="customerAddress1"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                            </div>


                            <div className={"row"}>
                                <div className={"col-sm-6 "}>
                                    <TextInput
                                        label="Postnummer"
                                        name="customerPostalCode"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-sm-6 "}>
                                    <TextInput
                                        label="Ort"
                                        name="customerCity"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        //placeholder="Doe"
                                    />
                                </div>
                            </div>

                            <div className={"row"}>
                                <div className={"col-sm-12 "}>
                                    <CheckboxInput
                                        id="customerUseSeparateShipping"
                                        label="Avvikande leveransadress"
                                        name="customerUseSeparateShipping"
                                        //onBlur={handleFieldBlur}
                                    >
                                        Kryssa i rutan om du vill ange en avvikande leveransadress
                                    </CheckboxInput>
                                </div>
                            </div>

                            {values.customerUseSeparateShipping && <div className="retailer-shipping-fields">
                                <h6 className="text-bold ">Leveransadress</h6>
                                <hr className="mb-3"/>
                                <div className={"row"}>
                                    <div className={"col-sm-12 "}>
                                        <TextInput
                                            label="Företagsnamn"
                                            name="customerShippingName"
                                            type="text"
                                            //onBlur={handleFieldBlur}
                                            // placeholder="F"
                                        /></div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-sm-12 "}>
                                        <TextInput
                                            label="Adress"
                                            name="customerShippingAddress1"
                                            type="text"
                                            //onBlur={handleFieldBlur}
                                            // placeholder="F"
                                        /></div>
                                </div>
                                <div className={"row"}>
                                    <div className={"col-sm-6 "}>
                                        <TextInput
                                            label="Postnummer"
                                            name="customerShippingPostalCode"
                                            type="text"
                                            //onBlur={handleFieldBlur}
                                            // placeholder="F"
                                        /></div>
                                    <div className={"col-sm-6 "}>
                                        <TextInput
                                            label="Ort"
                                            name="customerShippingCity"
                                            type="text"
                                            //onBlur={handleFieldBlur}
                                            //placeholder="Doe"
                                        />
                                    </div>
                                </div>
                            </div>
                            }

                            <h6 className="text-bold ">Leveranstider</h6>
                            <hr className="mb-3"/>

                            <div className={"row mb-1"}>
                                <div className={"col-sm-6"}>
                                    <div className={"form-group"}>
                                        <label>
                                    Kan ni ta emot leveranser måndag-fredag mellan 08-17?
                                        </label>
                                    </div>
                                </div>
                                <div className={"col-sm-6"}>
                                    <div className={"form-group"}>
                                    <RadioInput
                                        label="Ja"
                                        value="Ja"
                                        name="customerShippingOfficeHours"
                                        id="customerShippingFofficeHoursNo"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    />
                                    <RadioInput
                                        label="Nej"
                                        value="Nej"
                                        name="customerShippingOfficeHours"
                                        id="customerShippingFofficeHoursYes"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    />
                                    </div>

                                </div>

                                {errors.customerShippingOfficeHours && touched.customerShippingOfficeHours ? (
                                    <div className={"col-sm-12"}>
                                        <div className="form-control-feedback">
                                            * {errors.customerShippingOfficeHours}
                                        </div>
                                    </div>
                                ) : null}

                            </div>

                            {values.customerShippingOfficeHours === 'Nej' && <div className={"row"}>
                                <div className={"col-sm-12"}>
                                    <TextArea
                                        label="Leveranstider"
                                        name="customerShippingNote"
                                        type="text"
                                    /></div>
                            </div>}


                            <h6 className="text-bold mt-5 ">Kontaktperson</h6>
                            <hr className="mb-3"/>

                            <div className={"row"}>
                                <div className={"col-sm-6"}>
                                    <TextInput
                                        label="Förnamn"
                                        name="memberFirstName"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-sm-6 "}>
                                    <TextInput
                                        label="Efternamn"
                                        name="memberLastName"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        //placeholder="Doe"
                                    />
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className={"col-sm-6"}>
                                    <TextInput
                                        label="E-postadress"
                                        name="memberEmail"
                                        type="email"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                                <div className={"col-sm-6"}>
                                    <TextInput
                                        label="Telefonnummer"
                                        name="memberPhone"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>

                            </div>
                            {/*<div className={"row"}>*/}
                            {/*    <div className={"col-sm-6 "}>*/}
                            {/*        <TextInput*/}
                            {/*            label="Mobiltelefonnummer"*/}
                            {/*            name="memberMobilePhone"*/}
                            {/*            type="text"*/}
                            {/*        />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className={"row"}>
                                <div className={"col-sm-12"}>
                                    <TextArea
                                        label="Meddelande"
                                        name="memberMessage"
                                        type="text"
                                        //onBlur={handleFieldBlur}
                                        // placeholder="F"
                                    /></div>
                            </div>

                            <div className={"row"}>
                                <div className={"col-sm-12 "}>
                                    <CheckboxInput
                                        id="memberNewsletter"
                                        label="Nyhetsbrev"
                                        name="memberNewsletter"
                                        onBlur={handleFieldBlur}
                                    >
                                        Klicka i rutan för att få våra nyhetsbrev med info om nyheter och
                                        erbjudanden
                                    </CheckboxInput>
                                </div>

                                <div className={"col-sm-12 "}>
                                    <CheckboxInput
                                        id="memberConsent"
                                        label="Medgivande"
                                        name="memberConsent"
                                        onBlur={handleFieldBlur}
                                    >
                                        Ja, jag ger mitt medgivande till att spara och hantera den data jag angivit
                                        ovan.
                                    </CheckboxInput>
                                </div>
                            </div>


                            <ReCAPTCHA
                                ref={captchaRef}
                                sitekey={props.recaptchaV2Key}
                                onChange={(value) => {
                                    //console.log("$$$$onChange", value);
                                    //setFieldValue("recaptcha", value);
                                    setSubmitting(false);
                                }}
                                // onExpired={(value) => {
                                //     console.log("$$$$onExpired", value);
                                //     setFieldValue("memberConsent", false);
                                // }}
                                size="invisible"
                            />
                            <button className="btn btn-success"
                                    type="submit"
                                    disabled={isSubmitting}>Skicka din ansökan
                            </button>

                        </Form>
                    }
                    }
                </Formik>
            }
        </React.Fragment>
    );
};

@inject("store")
@observer
export default class DocTypeResellerApplication extends React.Component {
    constructor(props) {
        super(props);
        //this.ref = Math.random().toString(36).substr(2, 9);
    }

    render() {
        var content = this.props.model.content;
        return (<SignupForm
            recaptchaV2Key={this.props.store.navigation.recaptchaV2Key}
            berikssonStore={this.props.store.beriksson}
            nodeId={this.props.store.navigation.NodeId}
            cultureCode={this.props.store.navigation.CultureCode}
        />);
    }
}